module.exports = __webpack_public_path__ + "img/adobe-photoshop.ed2261ce.png";